import { EditSVG } from 'common-helpers/img';
import Button from 'components/Button';
import { AutoColumn } from 'components/Column';
import Modal from 'components/Modal';
import { GradientBorderBox } from 'components/styled/Box';
import styled from 'styled-components';

export const Wrapper = styled.div`
    flex: 1;
    display: flex;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        flex-direction: column;
        padding: 0 12px;
    `};

    .img {
        position: relative;
        border-radius: 8px 0 0 8px;
        width: 274px;
        height: 274px;

        ${({ theme }) => theme.mediaWidth.upToSmall`
            width: 100%;
            height: auto;
            border-radius: 8px 8px 0 0;
            max-width: 100%;
            background: #000;
        `};

        img {
            width: 100%;
            height: 100%;
            display: block;
            border-radius: 8px 0 0 8px;

            ${({ theme }) => theme.mediaWidth.upToSmall`
                border-radius: 8px 8px 0 0;
            `};
        }
    }

    .content {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        padding: 20px;
        background-color: #000;
        border-radius: 0 8px 8px 0;

        ${({ theme }) => theme.mediaWidth.upToSmall`
            flex: unset;
            border-radius: 0 0 8px 8px;
            height: 254px;
        `};

        .mintCapsule,
        .desc {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.5);
        }
        .sub-button {
            text-decoration: none;
            color: #fff;
            font-size: 10px;
            display: flex;
            .button-left {
                padding: 2px 4px;
            }
            .button-right {
                background: ${({ theme }) => theme.c.linearGradientBg};
                border-radius: 8px;
                padding: 2px 4px 2px 10px;
            }
            .arrow-wrapper {
                padding: 5px 8px;
                margin-left: 8px;
                border-radius: 10px;
                display: inline-block;
                color: #fff;
                background-color: #000;
                display: inline-flex;
                align-items: center;
                justify-content: center;
            }
        }

        .title {
            font-size: 18px;
            font-weight: 600;
            color: #fff;
        }

        .subtitle {
            font-size: 14px;
            color: #fff;
        }

        .tags {
            display: flex;
            gap: 10px;
        }

        button {
            width: fit-content;
            padding: 8px 30px;
            background-color: ${({ theme }) => theme.c.primary02};
            color: #fff;
            border-radius: 30px;
            border: 1px solid ${({ theme }) => theme.c.primary02};
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;

            &:disabled {
                border-color: #fff;
                background-color: #000;
                cursor: not-allowed;
                opacity: 0.6;
            }
            &.minted {
                border-color: ${({ theme }) => theme.c.primary02};
                background-color: ${({ theme }) => theme.c.primary02};
                opacity: 0.6;
            }
        }
    }
`;

export const StyledTag = styled(GradientBorderBox)`
    font-size: 10px;
    color: #fff;
    background-color: #000;
    padding: 6px 12px;
    border-radius: 20px;
`;

export const TopRightButton = styled(GradientBorderBox)`
    padding: 0;
    border-radius: 8px;
    text-decoration: none;
    color: #fff;
    font-size: 12px;
    display: flex;
`;

export const ModalWrapper = styled.div`
    /* width: 720px; */
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 100%;
    `};
`;

export const CardInfo = styled.div`
    width: 330px;
    border-radius: 30px;
    overflow: hidden;
    background-color: #000;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 100%;
    `};

    .avatar-wrapper {
        width: 100%;
        position: relative;
        padding-top: 100%;
        border-radius: 30px 30px 0 0;
        overflow: hidden;
    }
    .avatar {
        width: 100%;
        height: fit-content;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: fill;
    }
`;

export const CardContent = styled.div`
    width: 100%;
    padding: 10px 20px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding: 20px;
    `};
`;

export const CardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledEditSVG = styled(EditSVG)`
    width: 16px;
    height: 16px;
    color: #a0a0a0;
    cursor: pointer;
`;

export const InputRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-size: 12px;
    position: relative;
    /* .input-wrapper {
        position: relative;
        font-size: 12px;
        flex-grow: 1;
        flex: 1 1 0;
        height: 40px;
    } */
    input {
        outline: none;
        box-sizing: border-box;
        height: 40px;
        width: 100%;
        padding: 0 10px;
        border-radius: 10px;
        border: 1px solid #c0c0c0;
        font-size: 12px;
    }
    /* .input-suffix {
        position: absolute;
        right: 4px;
        bottom: 2px;
        color: rgba(0, 0, 0, 0.4);
        font-size: 8px;
    } */
    .name-suffix {
        flex-shrink: 0;
        font-weight: 700;
        margin-left: 4px;
        margin-right: 12px;
    }
    button {
        flex-shrink: 0;
    }
`;

export const CardInfoRowWrapper = styled(AutoColumn)`
    gap: 10px;
    margin-top: 10px;
`;

export const CardButton = styled(Button)`
    width: 100%;
    font-size: 16px;
    height: 42px !important;
    margin-top: 10px;
    font-weight: 600 !important;
    border-radius: 15px !important;
`;
export const CardFooterLink = styled.a`
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
    text-decoration: none;
    color: #fff;
`;
export const ArrowWrapper = styled.div`
    padding: 3px 6px;
    margin-left: 6px;
    border-radius: 10px;
    background-color: ${({ theme }) => theme.c.primary01};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const SuccessTitle = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const SuccessInfoAutoColumn = styled(AutoColumn)`
    gap: 10px;
`;

export const Tag = styled(GradientBorderBox)`
    font-size: 12px;
    color: #fff;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 8px;
`;

export const StyledModal = styled(Modal)`
    overflow-y: auto;
    .closeIcon {
        top: 140px;
        left: 56px;
        right: unset;
        ${({ theme }) => theme.mediaWidth.upToSmall`
            top: 8rem;
            left: 2rem;
            right: unset;
        `}
    }
`;
